<template>
    <div class="view view--program-create">
        <div class="has-margin-b30">
            <control
                name="titleControl"
                type="text"
                v-bind:label="__('Title')"
                v-model="program.title"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.title != null"
            >
                {{ errors.title[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="country"
                type="select"
                v-bind:label="__('Country')"
                v-model="program.countryId"
                v-bind:options="countries"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.country != null"
            >
                {{ errors.country[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="organizer"
                type="select"
                v-bind:label="__('Organizer')"
                v-model="program.organizerId"
                v-bind:options="organizers"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.organizer != null"
            >
                {{ errors.organizer[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="tags[]"
                type="tag"
                icon="search"
                label-field="title"
                placeholder="start typing the title of the tag here"
                v-bind:source-search="getTags"
                v-bind:label="__('Tags')"
                v-model="program.tags"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.tags != null"
            >
                {{ errors.tags[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="startAtControl"
                type="date"
                v-bind:date-config="dateConfig"
                v-bind:label="__('Start date')"
                v-model="program.startAt"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.start_at != null"
            >
                {{ errors.start_at[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="endAtControl"
                type="date"
                v-bind:date-config="dateConfig"
                v-bind:label="__('End date')"
                v-model="program.endAt"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.end_at != null"
            >
                {{ errors.end_at[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="shortDescriptionControl"
                type="textarea"
                v-bind:label="__('Short description')"
                v-model="program.shortDescription"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.short_description != null"
            >
                {{ errors.short_description[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="descriptionControl"
                type="textarea"
                v-bind:label="__('Description')"
                v-model="program.description"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.description != null"
            >
                {{ errors.description[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="goalControl"
                type="number"
                v-bind:label="__('Goal')"
                v-model="program.goal"
                v-bind:min="0"
                v-bind:step="0.1"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.goal != null"
            >
                {{ errors.goal[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="featuredVideoControl"
                type="file"
                ref="videoControl"
                v-bind:filename="program.videoUrl"
                v-bind:label="__('Featured video')"
                v-model="program.videoFile"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.featuredVideo != null"
            >
                {{ errors.featuredVideo[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="featuredImageControl"
                type="file"
                ref="imageControl"
                v-bind:filename="program.imageUrl"
                v-bind:label="__('Featured image')"
                v-model="program.imageFile"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.featuredImage != null"
            >
                {{ errors.featuredImage[0] }}
            </div>
        </div>

        <btn
            class="is-success"
            type="default"
            v-html="__('Create')"
            v-on:click="createProgram"
        ></btn>
    </div>
</template>

<script>
import MessageHandler from '../../messageHandler';
import store from '../../store';

import { Btn } from '@teamfurther/cinderblock';
import { Control } from '@teamfurther/cinderblock';
import ProgramRepository from '../../repositories/ProgramRepository';
import router from '../../router';
import CountryRepository from '../../repositories/CountryRepository';
import OrganizerRepository from '../../repositories/OrganizerRepository';
import TagRepository from '../../repositories/TagRepository';

const camelcaseKeys = require('camelcase-keys');

export default {
    components: {
        Btn,
        Control
    },
    created: function() {
        this.countryRepository = new CountryRepository();
        this.organizerRepository = new OrganizerRepository();
        this.programRepository = new ProgramRepository();
        this.tagRepository = new TagRepository();
    },
    data: function() {
        return {
            countries: [
                {
                    label: '',
                    value: ''
                }
            ],
            countryRepository: null,
            dateConfig: {
                enableTime: false
            },
            errors: {},
            organizers: [
                {
                    label: '',
                    value: ''
                }
            ],
            organizerRepository: null,
            program: {
                id: null,
                createdAt: null,
                countryId: null,
                deletedAt: null,
                description: '',
                endAt: '',
                goal: 0,
                imageFile: null,
                imageUrl: null,
                organizerId: null,
                shortDescription: '',
                startAt: null,
                tags: [],
                title: '',
                userId: null,
                updatedAt: null,
                videoFile: null,
                videoUrl: null,
            },
            programRepository: null,
            tagRepository: null
        };
    },
    methods: {
        createProgram: async function() {
            try {
                const data = {
                    country_id: this.program.countryId,
                    description: this.program.description,
                    end_at: this.program.endAt,
                    goal: this.program.goal,
                    image: this.program.imageFile,
                    imageName: this.$refs.imageControl.selectedFilename,
                    organizer_id: this.program.organizerId,
                    short_description: this.program.shortDescription,
                    start_at: this.program.startAt,
                    tags: this.program.tags.map(tag => tag.title),
                    title: this.program.title,
                    video: this.program.videoFile,
                    videoName: this.$refs.videoControl.selectedFilename
                };

                await this.programRepository.createProgram(data);

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Program was successfully created.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                await router.push({
                    path: '/programs'
                });
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        getCountries: async function() {
            try {
                this.countries = await this.countryRepository.getCountries();
                this.countries = this.countries.map(country => {
                    return {
                        label: country.name,
                        value: country.id
                    };
                });

                this.$set(this.program, 'countryId', this.countries[0].value);
            } catch (error) {}
        },
        getOrganizers: async function() {
            try {
                this.organizers = await this.organizerRepository.getOrganizers();
                this.organizers = this.organizers.map(organizer => {
                    return {
                        label: organizer.title,
                        value: organizer.id
                    };
                });

                this.$set(
                    this.program,
                    'organizerId',
                    this.organizers[0].value
                );
            } catch (error) {}
        },
        getTags: async function(search) {
            try {
                const tags = await this.tagRepository.getTags(search);

                if (tags.length === 0) {
                    return [
                        {
                            title: search,
                            id: 0
                        }
                    ];
                }

                return tags;
            } catch (error) {
                return [];
            }
        }
    },
    mounted: function() {
        this.getCountries();
        this.getOrganizers();
    }
};
</script>
